import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { FieldErrors, UseFormRegister, Path } from "react-hook-form";

type PasswordFieldProps<T extends Record<string, any>> = {
  register: UseFormRegister<T>;
  errors?: FieldErrors<T>;
  name: Path<T>;
  label?: string;
} & Omit<React.ComponentProps<typeof TextField>, "name" | "label">;

export default function PasswordField<T extends Record<string, any>>({
  register,
  errors,
  name,
  label = "Contraseña",
  ...rest
}: PasswordFieldProps<T>) {
  const [show, setShow] = useState(false);

  return (
    <TextField
      {...register(name)}
      variant="outlined"
      label={label}
      margin="normal"
      fullWidth
      required
      type={show ? "text" : "password"}
      helperText={errors?.[name]?.message as string}
      error={!!errors?.[name]?.message}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
              onClick={() => setShow((s) => !s)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
            >
              {show ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}
